const communicationInfoDialog = "info-dialog-communication"
const profilingInfoDialog = "info-dialog-profiling"
const disclaimerInfoDialog = "info-dialog-disclaimer"
const termsAndConditionFormInfoDialog = "info-dialog-terms"

export {
  communicationInfoDialog,
  disclaimerInfoDialog,
  profilingInfoDialog,
  termsAndConditionFormInfoDialog,
}
